/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const userRole = {
  PUBLIC: 'PUBLIC',
  SELF: 'SELF',
  ADMIN: 'ADMIN',
  BOND_PROVIDER: 'BOND_PROVIDER',
  LIQUIDITY_PROVIDER: 'LIQUIDITY_PROVIDER',
  TRADER: 'TRADER',
  INTEGRATOR: 'INTEGRATOR',
  INDEXER: 'INDEXER',
  COMPETITION_MANAGER: 'COMPETITION_MANAGER',
  AFFILIATE_MANAGER: 'AFFILIATE_MANAGER',
} as const

export type UserRole = (typeof userRole)[keyof typeof userRole]
